import ReactDOM from 'react-dom'
import App from './App.js';
import React from 'react';
import { AuthProvider } from "./Context/AuthContext";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { AppProvider } from './Context/AppContext.js';

ReactDOM.render(<BrowserRouter>
    <AuthProvider>
        <AppProvider>

            <App />
        </AppProvider>

    </AuthProvider>
</BrowserRouter>,
    document.getElementById('root'));